import { useMutation, useQueryClient } from '@tanstack/react-query';
import { StatusCode } from 'status-code-enum';
import { REACT_QUERY_KEYS } from '../../../../../../src/types/react-query-keys';
import { postApiV2CustomersCustomerIdUnhold as postUnholdAccount } from './post-api-v2-customers-customer_id-unhold';

/**
 * When an account is Paused (held) for x weeks, this useMutation hook can be used to unpause
 * @returns
 */
export function useUnholdAccount() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await postUnholdAccount();
      if (res.status !== StatusCode.SuccessNoContent) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }

      if (window.localStorage.getItem('latest-seen')) {
        window.localStorage.removeItem('latest-seen');
      }

      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [REACT_QUERY_KEYS.CUSTOMERS] });
    },
  });
}
